import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BasePage from '../../baseClasses/BasePage';
import Home from '../../containers/Home';
import MobileHeader from '../../components/MobileHeader';
import dataModel from '../../models/DataModel';
import InventoryEdit from '../../containers/TasksContainer/MobileTaskDetails/InventoryEdit/index.js';
import '../MobileWrapper.scss';
import mobileBridge from '../../helpers/MobileBridge';
import { RecordStates } from '../../constants/ReduxConstants';

const taskDescriptor = {
  task: {
    completion_criteria: {
    },
    inventory_items: {  inventory: {} },
    project: {},
  },
};
const inventoryItemDescriptor = {
  inventory_item: {
    inventory: {},
  },
};
export class InventoryEditWrapper extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      isRoot: false,
    };

  }

  componentDidMount() {
    if (this.props.location
        && this.props.location.search
        && this.props.location.search.indexOf('root') >= 0) {
      this.setState({ isRoot: true });
    }
    mobileBridge.initialize(this.props.history);
    this.handleGetElements();
  }

  async handleGetElements() {
    if (this.props.match.params.task_id) {
      const taskId = parseInt(this.props.match.params.task_id, 10);
      const taskRequest = dataModel.tasksDAO.getTask(taskId, { recordDescriptor: taskDescriptor });
      let inventoryItemRequest;
      if (this.props.match.params.inventory_item_id) {
        const inventoryItemId = parseInt(this.props.match.params.inventory_item_id, 10);
        inventoryItemRequest = dataModel.inventoryItemsDAO.getInventoryItem(inventoryItemId, { recordDescriptor: inventoryItemDescriptor });
      }
      Promise.all([taskRequest, inventoryItemRequest]).then(results => {
        const task = results[0];
        const inventoryItem = results[1];
        if (inventoryItem) {
          inventoryItem.name = inventoryItem.inventory ? inventoryItem.inventory.name : null;
          this.setState({ inventoryItem });
        }
        this.setState({ task_id: taskId, task });
      });
      
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionCableUpdate != this.props.actionCableUpdate) {
      this.setState({ actionCableUpdate: this.props.actionCableUpdate });
      this.handleGetElements();
    }
  }

  handleApplyFilters(filterArray) {
    this.props.projectsDAO.appliedProjectsFilters = filterArray;
  };

  handleClear = () => {
    this.handleApplyFilters([]);
  }

  render() {
    const { task, inventoryItem } = this.state;
    let waitSpinner = null;

    if (!task || (task._recordState == RecordStates.PENDING)) {
      waitSpinner = <Home type="transparent" />;
    }

    return (
      <div className='mobile-wrapper'>
        <MobileHeader
          headerTitle={inventoryItem ? 'Edit Inventory': 'Add Inventory'}
          rootPage={this.props.rootPage }
          noBackButton={this.state.isRoot}
          hasFilters={false}
          handleClear={this.handleClear}
        />
        {waitSpinner}
        <div className="content-wrapper">
          <InventoryEdit task={task} editInventoryItem={inventoryItem} forEdit={inventoryItem} />
        </div>
      </div>
    );
  }
}

InventoryEditWrapper.defaultProps = {
  rootPage: false,
};

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    actionCableUpdate: state.main.actionCableUpdate,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InventoryEditWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/InventoryEditWrapper/index.js